/**
 * Initialize the Swiper carousel once the slides are in the DOM.
 * Returns the Swiper instance in case you need to control it later.
 */
function initProductCarousel() {
  // 1) Grab the carousel container
  const carouselContainer = document.querySelector('.product-carousel');
  if (!carouselContainer) {
    console.warn('initProductCarousel: no .product-carousel found');
    return;
  }

  // 2) Create a new Swiper instance
  const swiper = new Swiper(carouselContainer, {
    // Base settings
    slidesPerView: 1.5,
    slidesPerGroup: 1,
    spaceBetween: 16,
    mousewheel: true,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    navigation: {
      nextEl: '.button-next',
      prevEl: '.button-prev',
    },
    breakpoints: {
      768: {
        slidesPerView: 3,
        slidesPerGroup: 3,
      },
      990: {
        slidesPerView: 4.2,
        slidesPerGroup: 4,
        spaceBetween: 18,
      },
    },
    observer: true,
    observeParents: true,
  });

  return swiper;
}

/**
 * IntersectionObserver callback:
 *  - waits until the recommendations section scrolls into view,
 *  - then fetche the HTML partial,
 *  - inject it,
 *  - init the carousel.
 */
function handleRecommendationsIntersection(entries, observer) {
  const entry = entries[0];

  // Only run when the section is actually visible
  if (!entry.isIntersecting) return;

  // We only want to load once
  observer.unobserve(entry.target);

  // Fetch the remote fragment (URL stored in data-url)
  fetch(entry.target.dataset.url)
    .then(response => {
      if (!response.ok) {
        throw new Error(`Fetch failed: ${response.status}`);
      }
      return response.text();
    })
    .then(htmlString => {
      // Parse the returned HTML
      const temp = document.createElement('div');
      temp.innerHTML = htmlString;

      // Extract only the .product-recommendations markup
      const recommendations = temp.querySelector('.product-recommendations');
      if (recommendations && recommendations.innerHTML.trim()) {
        // Inject into the placeholder
        entry.target.innerHTML = recommendations.innerHTML;

        // Now that the slides are in the DOM, initialize Swiper
        initProductCarousel();
      } else {
        console.info('No recommendation markup found to inject.');
      }
    })
    .catch(error => {
      console.error('Error loading product recommendations:', error);
    });
}
document.addEventListener('DOMContentLoaded', () => {
  const section = document.querySelector('.product-recommendations');
  if (!section) {
    console.warn('No .product-recommendations section found on this page.');
    return;
  }

  // Create an IntersectionObserver with a bit of pre-load margin
  const observerOptions = {
    rootMargin: '0px 0px 200px 0px',
  };
  const observer = new IntersectionObserver(handleRecommendationsIntersection, observerOptions);

  // Observe the section
  observer.observe(section);
});